import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import { MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import "./styles/styles.css";
import App from "./App";

const Root = (props) => {
    const { store, history, theme } = props;

    return (
        <Provider store={store}>
            <StylesProvider injectFirst>
                <MuiThemeProvider theme={theme}>
                    <ThemeProvider theme={theme}>
                        <App history={history} />
                    </ThemeProvider>
                </MuiThemeProvider>
            </StylesProvider>
        </Provider>
    );
}

export default Root;
